const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const DialogView = require('./dialog_view')
const log = require('log').create('dialog', 'behavior')  


const DialogBehavior = Marionette.Behavior.extend({

    initialize(options) {
        this.options = _.omit(options, 'behaviorClass')
        this.options.view = this.view

        _.bindAll(this, 'showDialog')

        // behavior is initialized very early
        // have to wait until view initialization is complete
        _.defer(this.showDialog)
    },

    showDialog() {
        this.dialog = new DialogView(this.options)
    },

    onBeforeDestroy() {
        log('destroy')
    },

})

DialogBehavior.config = function config(options = {}) {
    options.behaviorClass = DialogBehavior
    _.defaults(options, {
        // no defaults for this behavior, yet
    })
    return options
}

module.exports = DialogBehavior
